<template>
	<div>
		<base-header class="pb-6 bg-light">
			<!-- Page header -->
			<b-row aling-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">Portal Logs</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
		</base-header>
		<b-container>
			<b-card no-body>
                <b-card-header>
                    <b-row class="justify-content-center align-items-end pt-3">
                        <!-- <b-col>
                        </b-col> -->
                        <b-col cols="auto">
                            <label >Select Log:</label>
                            <b-form-select
                                id="options"
                                v-model="type"
                                :options="typeOptions"
                                size="sm"
                                class=""
                            ></b-form-select>
                        </b-col>
                        <!-- <b-col>
                        </b-col> -->
                        <b-col cols="auto">
                            <label >Search Term:</label>
                            <b-form-input
                                id="search-term"
                                v-model="searchedTerm"
                                placeholder="ex. XYZ,14"
                                type="text"
                                size="sm"
                                class=""
                            ></b-form-input>
                        </b-col>
                        <b-col sm="3" md="2">
                            <b-row class="justify-content-between" no-gutters>
                                <label for="invert-search" >Invert Search:</label>
                                <b-form-checkbox
                                    id="invert-search"
                                    v-model="invertSearch"
                                    placeholder="ex. XYZ,14"
                                    switch
                                    size="sm"
                                ></b-form-checkbox>
                            </b-row>
                            <b-row class="justify-content-between" no-gutters>
                                <label for="dump-file" >Auto Scroll:</label>
                                <b-form-checkbox
                                    id="dump-file"
                                    v-model="autoScroll"
                                    placeholder="ex. XYZ,14"
                                    switch
                                    size="sm"
                                ></b-form-checkbox>
                            </b-row>
                        </b-col>
                        <b-col></b-col>
                        <b-col cols="auto">
                            <b-button 
                            size="sm"
                            variant="warning"
                            @click="getDumpFile"
                            :disabled="getLogs"
                            >
                                <i class="fa fa-file-code"></i>
                                Dump File
                            </b-button>
                        </b-col>
                        <b-col cols="auto">
                            <b-button 
                            data-cy="portal-logs-start-btn"
                            size="sm"
                            :variant="getLogs ? 'danger' : 'success'"
                            @click="handleLoggingClick"
                            :disabled="loadingStatus"
                            >
                                <i class="fa fa-power-off"></i>
                                {{ getLogs ? "Stop" : "Start"  }} Logging
                            </b-button>
                        </b-col>
                        <b-col cols="auto">
                            <b-button 
                            size="sm"
                            variant="primary"
                            @click="reset"
                            >
                                Clear Output
                                <!-- Search <i class="fa fa-search"></i> -->
                            </b-button>
                        </b-col>
                        <b-col></b-col>
                    </b-row>
                </b-card-header>
				<b-card-body id="logs-display" class="p-3 scrollable bg-dark">
					<div class="text-center w-100" v-if="loadingStatus">
						<b-icon icon="three-dots" class="text-center" animation="cylon" font-scale="4"></b-icon>
					</div>
					<b-col cols="12">
						<div v-if="items.length > 0" class="opacity-0.8 p-4 rounded">
							<code>
								<span v-for="(item, index) in items"> 
                                    <div v-if="index >= items.length - newLogs" class="p-2 mb-1 border border-success">
                                        <p class="text-white">
                                            <strong>[{{ index + 1 }}] - </strong> {{ `${item}` }} <br /> 
                                        </p>
                                    </div>
                                    <p v-else class="text-white">
                                        <strong>[{{ index + 1 }}] - </strong> {{ `${item}` }} <br /> 
                                    </p>
                                </span>
							</code>
						</div>
						<div v-else-if="!loadingStatus && items.length === 0" class="opacity-0.8 p-4 rounded">
							<p class="text-center">No records to display.</p>
						</div>
					</b-col>
				</b-card-body>
                <b-card-footer>
                    <b-row>
                        <b-col>
                            <p>Showing {{ totalRows }} Log Entries</p>
                        </b-col>
                        <b-col>
                            <b-button variant="primary" @click="() => scrollToTop()" >Jump to Top</b-button>
                            <b-button variant="primary" @click="() => scrollToTop(true)" >Jump to Bottom</b-button>
                        </b-col>
                    </b-row>
                </b-card-footer>
			</b-card>
		</b-container>
	</div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb.vue";
import initService from "../../../common/api-services/init-service";
import administratorService from "../../../common/api-services/administrator-service";

export default {
	name: "PortalLogs",
	components: {
		RouteBreadCrumb,
	},
	mounted() {
		document.title = "Troubleshooting - SMS Router Log Search";

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/restricted").catch(() => {});
		}
	},
	data() {
		return {
            type: "ACCESS",
            typeOptions: [
                { value: "ACCESS", text: "Access" },
                { value: "ERRORS", text: "Error" },
                { value: "VHOST_ACCESS", text: "VHost Access" }
            ],
            totalRows: 0,
            loadingStatus: false,
            items: [],
            // noAccess: false,
            searchedTerm: "",
            invertSearch: false,
            dumpFile: false,
            getLogs: false,
            autoScroll: true,
            lastSize: 0,
            intervalId: null,
            newLogs: 0
		};
	},
	computed: {
        noAccess() {
            // Determine access based on menu link configuration
            let userRoles = initService.getUserRoles();
            let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

            if (!link) {
                return true;
            } else {
                userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
                return userRoles.length === 0;
            }
        }
	},
    watch: {
        getLogs: function (val) {
            if (val) {
                this.updateLogs();
            } else {
                clearInterval(this.intervalId);
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    },
	methods: {
		async getDumpFile() {
            this.loadingStatus = true;
            this.items = [];
            this.newLogs = 0;
            this.lastSize = 0;
            this.totalRows = 0;
            // this.searchedTerm = this.searchedTerm.trim();
            let payload = {
                type: this.type,
                search: '',
                invert: 0,
                dumpFile: 1,
                lastSize: 0
            };
            await administratorService.getPortalLogs(payload)
            .then(res => {
                console.log(res)
                if (res.size) {
                    for (const key in res.data) {
                        if (res.data.hasOwnProperty(key)) {
                            const element = res.data[key];
                            this.items.push(element);
                        }
                    }
                    this.lastSize = res.size;
                    this.totalRows = this.items.length;
                }
            })
            .finally(() => {
                this.loadingStatus = false;
                if (this.autoScroll) {
                    document.getElementById('logs-display').scrollTop = 9999999;
                }
            });
        },

        getPortalLogs() {
            this.searchedTerm = this.searchedTerm.trim();
            let payload = {
                type: this.type,
                search: this.searchedTerm,
                invert: this.invertSearch? 1 : 0,
                dumpFile: this.dumpFile? 1 : 0,
                lastSize: this.lastSize
            };

            administratorService.getPortalLogs(payload)
            .then(res => {
                console.log(res)
                if (res.size) {
                    for (const key in res.data) {
                        if (res.data.hasOwnProperty(key)) {
                            const element = res.data[key];
                            this.items.push(element);
                        }
                    }
                    this.lastSize = res.size;
                    this.newLogs = res.data.length? res.data.length : Object.keys(res.data).length;
                    this.totalRows = this.items.length;
                } else {
                    console.log("No new logs.")
                    // this.$toast("Error retrieving portal logs.", {type: "error"});
                }
            })
            .finally(() => {
                this.loadingStatus = false;
                if (this.newLogs > 0 && this.autoScroll) {
                    document.getElementById('logs-display').scrollTop = 9999999;
                }
            });
        },

        updateLogs() {
            this.intervalId = setInterval(() => {
                this.getPortalLogs();
            }, 4000);
        },

        handleLoggingClick() {
            this.getLogs = !this.getLogs;
            if (this.getLogs) {
                if (this.items.length === 0) {
                    this.loadingStatus = true;
                }
                this.getPortalLogs();
            }
        },

        reset() {
            this.items = [];
            this.newLogs = 0;
            this.lastSize = 0;
            this.totalRows = 0;
        },

        scrollToTop(invert=false) {
            if (invert) {
                this.autoScroll = true;
                document.getElementById('logs-display').scrollTop = 9999999;
            } else {
                this.autoScroll = false;
                document.getElementById('logs-display').scrollTop = 0;
            }
        }
	},
};
</script>

<style scoped>
.scrollable {
	height: 60vh;
	overflow-y: scroll;
}
</style>
